import { Injectable } from "@angular/core";
import {
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpEvent,
  HttpErrorResponse,
  HttpResponse,
  HttpXsrfTokenExtractor,
} from "@angular/common/http";
import { throwError as observableThrowError, Observable } from 'rxjs';
import { catchError, tap } from "rxjs/operators";
import { Router } from "@angular/router";
import { AppConstants } from "../constants/appconstants";
import { ServiceLocalStorage } from "./local-storage.service";
import { environment } from 'src/environments/environment.prod';
import { ApiConstants } from "../constants/api-path.constants";
import { RouterConstants } from "../constants/router.constants";
import { NotificationService } from "../shared/Utils/notification.service";

@Injectable({
  providedIn: 'root'
})
export class InterceptorService implements HttpInterceptor {
  state: any;
  constructor(private router: Router,
    private serviceLocalStorage: ServiceLocalStorage,
    private tokenExtractor: HttpXsrfTokenExtractor) {
    this.state = this.router.routerState.snapshot;
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let url = request.url;
    let loginApi = environment.baseUrl + ApiConstants.login;
    let getLoginOtp = environment.baseUrl + ApiConstants.getLoginOtp;
    let forgotpassword = environment.baseUrl + ApiConstants.forgotPassword;
    let updateUser = environment.baseUrl + ApiConstants.updateUser;
    let getUserById = environment.baseUrl + ApiConstants.getUserById;
    let fcmToken = ApiConstants.sendMessage;

    const requestMethod: string = request.method.toLowerCase();
    if (requestMethod && (requestMethod === 'get' || requestMethod === 'post' || requestMethod === 'delete' || requestMethod === 'put')) {
      const headerName = 'X-XSRF-TOKEN';
      const token = this.tokenExtractor.getToken() as string;
      if (token !== null && !request.headers.has(headerName)) {
        request = request.clone({ headers: request.headers.set(headerName, token) });
      }
    }

    if ((!url.includes(loginApi) && !url.includes(getLoginOtp) && !url.includes(forgotpassword) && !url.includes(updateUser) && 
          !url.includes(getUserById))) {
      request = request.clone({
        setHeaders: { Authorization: AppConstants.BEARER_STRING + this.serviceLocalStorage.getAuthToken() }
      });
    }

    return next.handle(request).pipe(tap((event: HttpEvent<any>) => {
      if (event instanceof HttpResponse) {
        //Take token form login api response and store it
        if (event.status === 200 && (url === loginApi)) {
          const bearerToken = event.headers.get(AppConstants.AUTH_TOKEN_STRING);
          if (bearerToken !== null && bearerToken.length > 0 && bearerToken.slice(0, AppConstants.BEARER_STRING.length) === AppConstants.BEARER_STRING) {
            this.serviceLocalStorage.setAuthToken(bearerToken.slice(AppConstants.BEARER_STRING.length, bearerToken.length));
          } else {
            console.error("Unable to fetch token");
          }
        }
      }
    }), catchError(response => {
      return this.handleError(response);
    }));
  }

  /**
     * Handle errors and give proper meaning msg to the user
     * @param error : Returns meaningful msg
  */

  handleError(error: HttpErrorResponse) {
    let errorData = {
      message: '',
      status: 0
    };
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      errorData.message = "A client-side or network error occurred.";
    } else {
      if (error.status == 400) {
        if (error.error.message == 'Malformed Token') {
          errorData.message = "Session Expired, Please login again.";
          this.router.navigate(['/auth']);
        } else if (error.error.message == 'Not Subscribed') {
          errorData = error.error;
        } else if (error.error.message == 'Check ToDate') {
          errorData = error;
        } else {
          errorData.message = error.error ? error.error.message ? error.error.message : error.error.error.message : "Empty error..";
        }
      } else if (error.status == 401) {
        var clientCode = localStorage.getItem("clientCode");
        var autoClientCheck = localStorage.getItem("AutoClientCheck");
        if (error.error.message == "Authentication Failed: Bad credentials") {
          errorData.message = "Wrong UserName / Password";
          this.router.navigate(['/' + RouterConstants.auth + '/' + RouterConstants.login])
        } else if (error.error.message == "Authentication Failed: Not able to find tenant DB" && autoClientCheck == null) {
          errorData.message = "Wrong Client Code";
        } else if (error.error.message == "Authentication Failed: Not able to find tenant DB" && autoClientCheck == "true") {
          errorData.message = "Wrong UserName / Password";
        } else if (error.error.message == "Account blocked") {
          errorData.message = "Account blocked due to multiple attempts. Please try again after 15 mins"
        } else if (error.error.message == "User is disabled") {
          errorData.message = "User is disabled. Please Contact Admin"
          // this.snackBar.openSnackBar(errorData.message, null);
        } else if (error.error.message.includes("Authentication Failed: SSO Enable :")) {
          const ssoLogIn = environment.ssoLogIn;
          window.location.href = ssoLogIn.replace(new RegExp('{clientCode}', 'g'), clientCode);
        } else {
          errorData.message = "Unauthourized access";
          // this.snackBar.openSnackBar(errorData.message, null);
        }
        this.serviceLocalStorage.deleteAll();
        if (clientCode != null) {
          localStorage.setItem("clientCode", clientCode);
        }
      } else if (error.status == 403) {
        errorData.message = "Error in getAuthentication";
        // this.snackBar.openSnackBar(errorData.message, null);
      } else if (error.status == 404) {
        errorData.message = "Server not found";
        // this.snackBar.openSnackBar(errorData.message, null);
      } else if (error.status == 406) {
        errorData.message = error.error.message;
      } else if (error.status == 409) {
        errorData.message = error.error.message;
        // this.snackBar.openSnackBar(errorData.message, null);
      } else if (error.status == 500) {
        errorData.message = "Server error";
        errorData.status = error.status;
        // this.snackBar.openSnackBar(errorData.message, null);
      } else {
        errorData.message = "Network error occured. Please try again later.";
        // this.snackBar.openSnackBar(errorData.message, null);
      }
    }
    return observableThrowError(errorData);
  }
}
